var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-secondary",attrs:{"type":"button","disabled":_vm.disAttribute},on:{"click":function($event){return _vm.$emit('btn-secondary')}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }